import React from 'react'
import { connect } from 'react-redux'
import Resx from '@/components/Resx'
import { Main, MainTop, MainTopTitle, MainBody, MainTopLeft } from '@/components/Layout/Layout.Main'
import { WhiteBox } from '@/components/Layout/Layout.Box'
import { actionCreators } from '@/store/usersManagement'
import { localized } from '@/decorators/localized'
import {
  BsrsGrid,
  actionButtonsColumnProps,
  BooleanCellStatus,
  BooleanFilterCell,
  DateCell,
  DateTimeCell,
  DateFilterCell,
  DateTimeFilterCell,
  BooleanColumn
} from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import Icon from '@/components/Icon'
import context from '@/context'
import { Link } from 'react-router-dom'

const mapStateToProps = (state, ownProps) => {
  return {
    ...state.usersManagement,
    ...ownProps
  }
}

const mapDispatchToProps = {
  resetState: actionCreators.resetState,
  setUserState: actionCreators.setUserState,
  generatePasswordResetToken: actionCreators.generatePasswordResetToken,
  approveUser: actionCreators.approveUser,
  deleteUser: actionCreators.deleteUser
}

@connect(mapStateToProps, mapDispatchToProps)
@localized()
class UsersManagementList extends React.Component {
  constructor (props, context) {
    super(props, context)

    props.resetState()
  }

  setUserState (e) {
    this.props.setUserState({
      id: e.id,
      stateCode: 'BlockOrActivate'
    })
  }

  generatePasswordResetToken (e) {
    this.props.generatePasswordResetToken(e.emailAddress)
  }

  getButtons = (dataItem) => {
    let sourceActionButtons = []
    const { localize } = this.props

    sourceActionButtons.push({
      url: x => `/users/${x.id}`,
      title: localize('UsersManagement.Detail'),
      icon: 'pencil'
    })

    if (dataItem.approvedAt === null) {
      sourceActionButtons.push({
        icon: 'check',
        onConfirm: item => {
          this.props.approveUser(item.id)
        },
        confirmTitle: 'UsersManagement.ApproveConfirmTitle',
        confirmText: 'UsersManagement.ApproveConfirmText'
      })
    }

    if (!dataItem.isEmailConfirmed) {
      sourceActionButtons.push({
        icon: 'trash',
        onConfirm: item => {
          this.props.deleteUser(item.id)
        },
        confirmTitle: 'UsersManagement.DeleteConfirmTitle',
        confirmText: 'UsersManagement.DeleteConfirmText'
      })
    }

    sourceActionButtons.push({
      title: localize('UsersManagement.DeactivateUserTool'),
      icon: x => x.isActive ? 'lock-open' : 'lock',
      onConfirm: item => {
        this.setUserState(item)
      },
      confirmTitle: item => item.isActive ? 'UsersManagement.SetInactiveConfirmTitle' : 'UsersManagement.SetActiveConfirmTitle',
      confirmText: item => item.isActive ? 'UsersManagement.SetInactiveConfirmText' : 'UsersManagement.SetActiveConfirmText'
    })

    if (dataItem.isActive) {
      sourceActionButtons.push({
        title: localize('UsersManagement.ResetPassword'),
        icon: 'key',
        onConfirm: item => {
          this.generatePasswordResetToken(item)
        },
        confirmTitle: 'UsersManagement.ResetPasswordConfirmTitle',
        confirmText: 'UsersManagement.ResetPasswordConfirmText'
      })
    }

    return sourceActionButtons
  }

  render () {
    const { localize, lastReloadAt } = this.props

    return (<Main>
      <MainTop>
        <MainTopTitle>
          <Resx name='UsersManagement.Title' />
        </MainTopTitle>
        <MainTopLeft>
          <Link className='btn btn-primary btn-sm' to='/users/add/0'>
            <Icon name='plus' /> <span><Resx name='UsersManagement.CreateCBIAccount' /></span>
          </Link>
          <Link className='btn btn-primary btn-sm' to='/users/add/1'>
            <Icon name='plus' /> <span><Resx name='UsersManagement.CreateInstitutionAccount' /></span>
          </Link>
        </MainTopLeft>
      </MainTop>
      <MainBody clear>
        <WhiteBox>
          <BsrsGrid dataSource={context.api.userManagementService.getUsers} persistenceId='users' lastReloadedAt={lastReloadAt}>
            <Column field='userName' title={localize('UsersManagement.UserName')} />
            <Column field='emailAddress' title={localize('UsersManagement.EmailAddress')} />
            <Column field='creationTime' title={localize('UsersManagement.CreationTime')} filter='date' cell={DateCell} filterCell={DateFilterCell} width='120px' />
            <Column field='lastModificationTime' title={localize('UsersManagement.LastModificationTime')} filter='date' cell={DateCell} filterCell={DateFilterCell} width='120px' />
            <Column field='lockoutEndDateUtc' title={localize('UsersManagement.LockoutEndDateUtc')} filter='date' cell={DateTimeCell} filterCell={DateTimeFilterCell} width='120px' />
            <Column field='lastLoginTime' title={localize('UsersManagement.LastLoginTime')} filter='date' cell={DateTimeCell} filterCell={DateTimeFilterCell} width='120px' />
            <Column field='approvedAt' title={localize('UsersManagement.ApprovedAt')} filter='date' cell={DateTimeCell} filterCell={DateTimeFilterCell} width='120px' />
            <Column field='accessFailedCount' title={localize('UsersManagement.AccessFailedCount')} width='110px' />
            {BooleanColumn({ field: 'isTwoFactorEnabled', title: localize('UsersManagement.IsTwoFactorEnabled'), width: '120px' })}
            {BooleanColumn({ field: 'isEmailConfirmed', title: localize('UsersManagement.IsEmailConfirmed'), width: '120px' })}
            {BooleanColumn({ field: 'isInternalUser', title: localize('UsersManagement.IsInternalUser'), width: '120px' })}
            {BooleanColumn({ field: 'canBeImpersonated', title: localize('UsersManagement.CanBeImpersonated'), width: '120px' })}
            <Column field='isActive' title={localize('UsersManagement.IsActive')} cell={BooleanCellStatus} filterCell={BooleanFilterCell} width='120px' />
            <Column title={localize('UsersManagement.Action')} {...actionButtonsColumnProps(this.getButtons.bind(this))} />
          </BsrsGrid>
        </WhiteBox>
      </MainBody>
    </Main>)
  }
}

export default UsersManagementList



// WEBPACK FOOTER //
// ./src/internal-app/pages/usersManagement/UsersManagementList.js